export const isApiAuthReady = ({ getToken, isSignedIn }) =>
  typeof getToken === 'function' && isSignedIn === true;
